<template>
  <div id="main-content" class="contact-us-confirmation-page">
    <Alert v-if="!loadingRelatedArticles && relatedArticles.length === 0" alertType="error" />

    <ConfirmationPage :isPublicSite="false" :refData="formResponse" />

    <section v-if="!loadingRelatedArticles && relatedArticles.length !== 0" class="page-section">
      <h2>Related articles</h2>
      <QuickLinks :linksData="relatedArticles" />
    </section>
  </div>
</template>

<script>
import { CONTACT_US } from '@/router/routeNames';
import { getNavigationState } from '@/router/navigationState';
import ConfirmationPage from '@general/js/components/ContactUsConfirmation.vue';
import { Alert, QuickLinks } from '@/components';
import SupportServices from '@/services/Support';

export default {
  name: 'memberPortalContactUsConfirmation',

  components: {
    Alert,
    ConfirmationPage,
    QuickLinks,
  },

  data() {
    return {
      formResponse: null,
      loadingRelatedArticles: true,
      relatedArticles: [],
    };
  },

  async beforeMount() {
    this.formResponse = getNavigationState().formResponse;

    // if there is no data passed from contact us page, redirect to contact us page
    if (!this.formResponse) {
      this.$router.push({ name: CONTACT_US });
    }

    try {
      this.loadingRelatedArticles = true;
      const data = await SupportServices.getContactUsConfirmationReferenceData();
      this.relatedArticles = [data?.relatedArticle1, data?.relatedArticle2, data?.relatedArticle3];
    } catch (error) {
      logger.error(error);
    } finally {
      this.loadingRelatedArticles = false;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@general/styles/_contact-us.scss';

.page-section {
  margin: 56px 0;

  @include mobile {
    margin: 24px 0;
  }
}
</style>
